<ng-container *ngIf="project$ | async as project">

  <app-page-title [title]="title" [useBackButton]="false" isBoldedTitle="true">
    <ng-template>
      <button (click)="action(project, null)" class="btn-sm mx-1" color="primary" mat-raised-button>
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{'Add Recommendation' | concat | translate}}
      </button>
    </ng-template>
  </app-page-title>

   <div class="col-md-12 my-3">
      <h5>{{'Project Summary' | concat | translate}}</h5>
        <div class="ext-container w-100">
          <mat-card class="inst-details">
            <div class="row">

              <div class="col-md-6 my-2">
                <span class="title">{{'Project Name' | concat | translate}}</span>
                <div>{{ project?.name}}</div>
              </div>

              <div class="col-md-6 my-2">
                <span class="title">{{'Project Location' | concat | translate}}</span>
                <div>{{ project?.location}}</div>
              </div>
            </div>
          </mat-card>
        </div>
    </div>

  <div class="row mt-3">
    <div class="col-md-12">
      <app-data-table [columnHeader]="tableColumn" [tableData$]="recommendations$" hasActionsColumn="false">
        <ng-template let-data="data">

          <div class="action-icons">

            <ng-container *ngIf="project?.projectStatusEnum !== projectStatus.COMPLETED; else notEditable">
              <button [matMenuTriggerFor]="menu" class="icon-holder" mat-icon-button>
                <mat-icon svgIcon="option"></mat-icon>
              </button>
            </ng-container>

            <mat-menu #menu="matMenu">
                <button (click)="action(project, data)" mat-menu-item>
                  <mat-icon svgIcon="edit"></mat-icon>
                  {{'Edit' | concat | translate}}
                </button>

                <button (click)="remove(data)" mat-menu-item>
                  <mat-icon svgIcon="icon_deactivate"></mat-icon>
                  {{'Remove' | concat | translate}}
                </button>
            </mat-menu>

            <ng-template #notEditable>
              <button disabled mat-raised-button> <mat-icon class="material-symbols-outlined">info</mat-icon>
                {{'Cant be Editable' | concat | translate}} </button>
            </ng-template>

          </div>

        </ng-template>
      </app-data-table>
    </div>
  </div>

</ng-container>
